import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REOPEN_MENU_CURATION_TASK_MUTATION } from '../graphql/mutations'
import { REOPEN_MENU_CURATION_TASK } from '../redux/action-types'

const useReopenMenuCurationTaskMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateLoading: isLoading, updateError: error } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const mutate = useCallback(
    id =>
      apolloService.mutate({
        mutation: REOPEN_MENU_CURATION_TASK_MUTATION,
        variables: { id },
        dispatch,
        action: REOPEN_MENU_CURATION_TASK,
      }),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useReopenMenuCurationTaskMutation
